import { render, staticRenderFns } from "./CubageValidationAlerts.vue?vue&type=template&id=4b506c5f&scoped=true"
import script from "./CubageValidationAlerts.vue?vue&type=script&lang=js"
export * from "./CubageValidationAlerts.vue?vue&type=script&lang=js"
import style0 from "./CubageValidationAlerts.vue?vue&type=style&index=0&id=4b506c5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b506c5f",
  null
  
)

export default component.exports